import i18n from "@/libs/i18n";
export default [
  {
    get header() {
      return i18n.t("warehouse.warehouse");
    },
    permission: "get-department", // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    role: "Warehouse",
  },
  {
    get title() {
      return i18n.t("warehouse.warehouse-dashboard");
    },
    route: "warehouse",
    icon: "ShoppingBagIcon",
    permission: "get-warehouse",
    role: "Warehouse",
  },
  {
    get title() {
      return i18n.t("warehouse.department");
    },
    route: "department",
    icon: "LayersIcon",
    permission: "get-department",
    role: "Warehouse",
  },
  {
    get title() {
      return i18n.t("warehouse.category");
    },
    route: "category",
    icon: "LayersIcon",
    permission: "get-category",
    role: "Warehouse",
  },
  {
    get title() {
      return i18n.t("warehouse.item");
    },
    route: "item",
    icon: "ArchiveIcon",
    permission: "get-item",
    role: "Warehouse",
  },
  {
    get title() {
      return i18n.t("warehouse.stockin");
    },
    route: "stockin",
    icon: "LogInIcon",
    permission: "get-stockin",
    role: "Warehouse",
  },
  {
    get title() {
      return i18n.t("warehouse.stockout");
    },
    route: "stockout",
    icon: "ExternalLinkIcon",
    permission: "get-stockout",
    role: "Warehouse",
  },
  // {
  //   get title() {
  //     return i18n.t("warehouse.inventory-invoice");
  //   },
  //   route: "inventory-invoice",
  //   icon: "BoxIcon",
  //   permission: "get-inventoryInvoice",
  //   role: "Warehouse",
  // },
  {
    get title() {
      return i18n.t("warehouse.warehouse-transfer");
    },
    route: "warehouse-transfer",
    icon: "ListIcon",
    permission: "get-balance",
    role: "Warehouse",
  },
  {
    get title() {
      return i18n.t("warehouse.balance");
    },
    route: "balance",
    icon: "BarChart2Icon",
    permission: "get-balance",
    role: "Warehouse",
  },
  {
    get title() {
      return i18n.t("warehouse.department-balance");
    },
    route: "department-balance",
    icon: "BarChart2Icon",
    permission: "get-department",
    role: "department",
  },
  {
    get title() {
      return i18n.t("warehouse.minimum-reorder-quantity");
    },
    route: "minimum-reorder-quantity",
    icon: "ShoppingBagIcon",
    permission: "get-warehouse",
    role: "Warehouse",
  },
];
